import TSAbstractEntity from './TSAbstractEntity';
import {TSSerializable} from './TSSerializable';
import TSFinanzangabenDaten from './TSFinanzangabenDaten';

export default class TSFinanzangaben extends TSAbstractEntity implements TSSerializable<TSFinanzangaben> {

    private _finanzangabenDatenFS: TSFinanzangabenDaten;

    private _finanzangabenDatenGS: TSFinanzangabenDaten | undefined;

    private _zustimmungSteuerpruefung: boolean;

    private _zustimmungPruefungFondsuisse: boolean;

    private _steuerdatenGeprueft: boolean;

    constructor() {
        super();
        this._finanzangabenDatenFS = new TSFinanzangabenDaten;
    }

    public get finanzangabenDatenFS(): TSFinanzangabenDaten {
        return this._finanzangabenDatenFS;
    }

    public set finanzangabenDatenFS(value: TSFinanzangabenDaten) {
        this._finanzangabenDatenFS = value;
    }

    public get finanzangabenDatenGS(): TSFinanzangabenDaten | undefined {
        return this._finanzangabenDatenGS;
    }

    public set finanzangabenDatenGS(value: TSFinanzangabenDaten | undefined) {
        this._finanzangabenDatenGS = value;
    }

    public get zustimmungSteuerpruefung(): boolean {
        return this._zustimmungSteuerpruefung;
    }

    public set zustimmungSteuerpruefung(value: boolean) {
        this._zustimmungSteuerpruefung = value;
    }

    public get zustimmungPruefungFondsuisse(): boolean {
        return this._zustimmungPruefungFondsuisse;
    }

    public set zustimmungPruefungFondsuisse(value: boolean) {
        this._zustimmungPruefungFondsuisse = value;
    }

    public get steuerdatenGeprueft(): boolean {
        return this._steuerdatenGeprueft;
    }

    public set steuerdatenGeprueft(value: boolean) {
        this._steuerdatenGeprueft = value;
    }

    deserialize(restObject: any): TSFinanzangaben {
        super.deserialize(restObject);
        this.finanzangabenDatenFS = this.deserializeOrCreate(restObject.finanzangabenDatenFS, new TSFinanzangabenDaten());
        this.finanzangabenDatenGS = this.deserializeOrNull(restObject.finanzangabenDatenGS, new TSFinanzangabenDaten());
        this.zustimmungSteuerpruefung = restObject.zustimmungSteuerpruefung;
        this.zustimmungPruefungFondsuisse = restObject.zustimmungPruefungFondsuisse;
        this.steuerdatenGeprueft = restObject.steuerdatenGeprueft;
        return this;
    }

    serialize(restObject: any): any {
        super.serialize(restObject);

        restObject.zustimmungSteuerpruefung = this.zustimmungSteuerpruefung;
        restObject.zustimmungPruefungFondsuisse = this.zustimmungPruefungFondsuisse;
        restObject.finanzangabenDatenFS = this.serializeOrInit(this.finanzangabenDatenFS, restObject.finanzangabenDatenFS);
        restObject.finanzangabenDatenGS = this.serializeOrInit(this.finanzangabenDatenGS, restObject.finanzangabenDatenGS);
        restObject.steuerdatenGeprueft = this.steuerdatenGeprueft;
        return restObject;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSFinanzangaben.ts